import { render, staticRenderFns } from "./HomeProtection.vue?vue&type=template&id=f0ce5250"
import script from "./HomeProtection.vue?vue&type=script&lang=js"
export * from "./HomeProtection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports